import { render, staticRenderFns } from "./ProposalsTab.vue?vue&type=template&id=c6f07292&scoped=true&"
import script from "./ProposalsTab.vue?vue&type=script&lang=js&"
export * from "./ProposalsTab.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsTab.vue?vue&type=style&index=0&id=c6f07292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f07292",
  null
  
)

export default component.exports